<template>
  <div :class="selector ? 'edit-wrapper': ''">
    <div :class="selector ? 'edit-form':''">
    <div v-if="selector"><el-button type="primary" plain @click="$emit('close-address-book')" style="width: 100%;">Go back and enter a new address.</el-button></div>
    <div v-if="selector" style="font-size: 130%; font-weight: 700; margin-top: 16px;"> Select address.</div>
    <div v-if="selector" style="font-size: 90%; font-weight: 300; margin-bottom: 16px;"> Tip: You can edit the address after select it.</div>
    <div v-if="!selector" style="font-size: 90%; font-weight: 300;">
      <el-button @click="editAddress('add')" style="width: 100%; margin: 16px 0;" type="primary">Add a new address</el-button>
    </div>
    <el-input v-model="addressQuery" placeholder="Search" style="margin: 12px 0">
      <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
    </el-input>
    <el-table :data="displayedAddress" style="padding-bottom: 20px;">
      <el-table-column
        prop="alias"
        label="Alias"
        align="center">
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        align="center">
      </el-table-column>
      <el-table-column
        label="Address"
        align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.province + ' ' + scope.row.city + ' ' + scope.row.district }}</div>
          <div>{{ scope.row.addressInfo }}</div>
          <div>{{ scope.row.postal }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="Tel."
        align="center">
      </el-table-column>
      <el-table-column
        prop="ID"
        label="ID"
        align="center">
      </el-table-column>
      <el-table-column
        label="action"
        fixed="right">
        <template slot-scope="scope">
          <div v-if="!selector">
            <el-tooltip content="Edit" placement="bottom" effect="light">
              <i class="material-icons"  @click="editAddress('edit', scope.row)" style="cursor: pointer;">edit</i>
            </el-tooltip>
            <el-tooltip content="Duplicate" placement="bottom" effect="light">
              <i class="material-icons"  @click="editAddress('copy', scope.row)" style="cursor: pointer;">file_copy</i>
            </el-tooltip>
            <el-tooltip content="Delete" placement="bottom" effect="light">
              <i class="material-icons"  @click="deleteAddress(scope.row)" style="cursor: pointer;">delete_forever</i>
            </el-tooltip>
          </div>
          <div v-if="selector">
            <el-tooltip content="Use this address" placement="bottom" effect="light">
              <el-button @click="selectAddress(scope.row)">Select</el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <half-circle-spinner
          v-if="!loadingBarTimeout"
          :animation-duration="1200"
          :size="48"
          color="#ff1d5e"
          style="margin:32px auto;"
        />
        <div v-if="loadingBarTimeout" style="z-index: 999; background-color: #ffffff; position: absolute; top: 20px; padding-bottom: 20px; left: 0">
          Can't find any address here. You can <a href="#" @click="linkAddress()"> refresh </a> Or, <a href="#" @click="editAddress('add')"> add a new address?</a>
        </div>
      </template>
    </el-table>
    <div style="overflow: auto; margin-top: 2rem">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :total="resultAddress.length"
        :page-size="addressPerPage">
      </el-pagination>
    </div>
    <address-editor
      v-if="showAddressEditor"
      :address="editingAddress"
      v-on:close-address-editor="closeAddressEditor">
    </address-editor>
    </div>
  </div>
</template>

<script>
/* eslint-disable handle-callback-err */

import { db } from '../main'
import { HalfCircleSpinner } from 'epic-spinners'
import { searchAddress, deleteAddress } from '../../public/js/addressBook'
import AddressEditor from '@/components/AddressEditor'

export default {
  name: 'AddressBook',
  props: ['user', 'selector'],
  data () {
    return {
      addressQuery: '',
      allAddress: [],
      searchedAddress: [],
      currentPage: 1,
      addressPerPage: 20,
      showAddressEditor: false,
      editingAddress: null,
      loadingBarTimeout: false
    }
  },
  timers: {
    linkAddress: {
      time: 1000,
      autostart: true,
      repeat: false
    },
    killLoadingBar: {
      time: 10000,
      autostart: false,
      repeat: false
    }
  },
  methods: {
    linkAddress: function () {
      this.$timer.stop('killLoadingBar')
      this.$timer.start('killLoadingBar')
      this.loadingBarTimeout = false
      // console.log('link address book')
      let user = this.user
      if (!user) {
        // console.log('user not ready for loading the address book')
        return
      }
      let uid = user.uid
      this.$bind('allAddress', db.collection('addressBook').where('owner', '==', uid).orderBy('alias'))
    },
    doSearch: function () {
      this.searchedAddress = searchAddress(this.allAddress, this.addressQuery)
    },
    editAddress: function (action, address) {
      // console.log(action, address)
      let addressData = address
      if (action === 'add') {
        addressData = {
          docId: '',
          alias: 'New Address',
          name: '',
          phone: '',
          ID: '',
          addressInfo: '',
          district: '',
          city: '',
          province: '',
          postal: '',
          country: '中国',
          owner: this.user.uid
        }
      } else if (action === 'copy') {
        addressData.docId = ''
        addressData.alias = 'Copy of ' + addressData.alias
      }
      this.editingAddress = JSON.parse(JSON.stringify(addressData))
      this.showAddressEditor = true
    },
    deleteAddress: function (address) {
      let that = this
      that.$confirm('This address will be deleted permanently from your address book.', 'Head Up!', {
        type: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      })
        .then(() => {
          return deleteAddress(address).then(() => {
            that.$message('Address deleted')
          })
        })
        .catch(() => {
          // console.log('Delete canceled')
        })
    },
    selectAddress: function (address) {
      this.$emit('select-address', address)
    },
    closeAddressEditor: function () {
      this.showAddressEditor = false
      this.linkAddress()
    },
    killLoadingBar: function () {
      this.loadingBarTimeout = true
    }
  },
  watch: {
    user: function () {
      // console.log('user changed, bind address')
      this.linkAddress()
    }
  },
  computed: {
    resultAddress: function () {
      let resultAddress = []
      let useQuery = this.addressQuery !== ''
      if (!useQuery) {
        resultAddress = this.allAddress
      } else {
        resultAddress = this.searchedAddress
      }
      return resultAddress
    },
    displayedAddress: function () {
      let start = this.addressPerPage * (this.currentPage - 1)
      let end = this.addressPerPage * this.currentPage
      return this.resultAddress.slice(start, end)
    },
    existsAlias: function () {
      return null
    }
  },
  components: {
    AddressEditor,
    HalfCircleSpinner
  }
}
</script>

<style>

</style>
